/**
 * Agent Settings Resource
 *
 * Global agent runtime settings: envelope thresholds, retrieval page sizes,
 * and the bridge spill threshold. Readable by any authenticated user. The
 * values are seeded and read-only at runtime — changing one is a seed change
 * and a deployment (authz ADR-d5288).
 */

import type { HttpLayer } from '../http.js';

export interface AgentSettingRow {
  key: string;
  value: unknown;
  description: string;
  updated_at: string;
}

export interface AgentSettingsList {
  settings: AgentSettingRow[];
}

export class AgentSettingsResource {
  constructor(private http: HttpLayer) {}

  private prefix = '/v1/platform';

  async list(): Promise<AgentSettingsList> {
    return this.http.get(`${this.prefix}/agent-settings`);
  }
}
